const getTimestamp = () => new Date().getTime();
export class PerformanceService {
    events = {};
    start(name, meta = {}) {
        this.events[name] = { start: getTimestamp(), end: null, meta };
    }
    setMeta(name, meta = {}) {
        if (!this.events[name])
            return;
        this.events[name] = { ...this.events[name], meta: { ...this.events[name].meta, ...meta } };
    }
    stop(name, endMeta = {}) {
        if (!this.events[name])
            return;
        this.events[name] = { ...this.events[name], end: getTimestamp(), meta: { ...this.events[name].meta, ...endMeta } };
    }
    deleteMark(name) {
        delete this.events[name];
    }
    getMeasurement(name, sendMeta = {}) {
        const event = this.events[name];
        if (!event)
            return;
        if (!event.end)
            this.stop(name);
        const { start, end, meta } = event;
        const durationMs = end ? end - start : 0;
        this.deleteMark(name);
        return { ...meta, ...sendMeta, name, durationMs };
    }
    isRunning(name) {
        return !!this.events[name];
    }
}
export const performanceService = new PerformanceService();
//# sourceMappingURL=performance.service.js.map